import React from 'react';
import { Box } from '@mui/material';
import { spacing } from 'common/theme';
import { IconHot } from 'components/common/IconHot';
import { TextHot } from 'components/common/TextHot';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { generateTestId } from 'app/functions';


const SectionNavigator = ({ title, onClick, testID }) => (
  <Box 
    testId={testID} 
    onClick={onClick}
    sx={{ 
      cursor: 'pointer', 
      width: '100%',
      '&:hover': {
        opacity: 0.8
      }
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingY: `${spacing.lg}px`,
        paddingX: `${spacing.xs}px`
      }}
    >
      <TextHot 
        size="xxl" 
        bold="bold" 
        color="primary"
        testID={generateTestId(testID, 'text')}
      >
        {title}
      </TextHot>

      <IconHot 
        src={ChevronLeftIcon} 
        size={20} 
        sx={{ transform: 'rotate(0deg)' }}
      />
    </Box>
  </Box>
);

export default SectionNavigator;